import { App } from './app.class';
import { Fetch } from '../fetch.class';

export class Page {

    constructor() {

        // Paddle initialisieren
        Paddle.Setup({ vendor: 120516 });

        // Paddle Checkout
        const $btnsCheckout = document.querySelectorAll('button.paddle-checkout');
        $btnsCheckout.forEach($btn => {
            $btn.addEventListener('click', event => {

                const frequencyValue = document.querySelector('input[name="frequency"]:checked').value;
                const isYearly = frequencyValue=='annually';

                const $ele = event.currentTarget;

                let productId = 0;
                if(isYearly) productId = parseInt($ele.getAttribute('data-productid-yearly'), 10 );
                else         productId = parseInt($ele.getAttribute('data-productid-monthly'), 10 );

                const account_email = $ele.getAttribute('data-account-email');
                const account_id = parseInt( $ele.getAttribute('data-account-id') );
                const locale = $ele.getAttribute('data-locale');
                const timezone = $ele.getAttribute('data-timezone');
                const title = $ele.getAttribute('data-title');
                const plan = $ele.getAttribute('data-plan');
                const referrer = $ele.getAttribute('data-referrer');

                const passthrough = {};
                if(account_id)      passthrough.account_id = account_id;
                if(locale)          passthrough.lang = locale;
                if(timezone)        passthrough.timezone = timezone;
                if(referrer)        passthrough.referrer = referrer;

                const para = {
                    product: productId,
                    passthrough: JSON.stringify(passthrough),
                    allowQuantity: false,
                    locale: locale,
                    successCallback: data => {

                        // Weiterleitung zu Seite Order-Processing
                        App.gotoUrl(App.getUrl('panel/membership/order_processing', { paddle_user_id: data.user.id, to_plan: plan, lang: locale }));
                    },
                };
                if(account_email)   para.email = account_email;
                if(title)           para.title = title;

                Paddle.Checkout.open(para);
            });
        });

        // Paddle Tarifwechsel
        const $btnsChange = document.querySelectorAll('button.paddle-change');
        $btnsChange.forEach($btn => {
            $btn.addEventListener('click', event => {

                const $ele = event.currentTarget;

                // Attribute übernehmen
                const $btnChangeNow = document.querySelector('#modal-plan-change button.paddle-change-now');
                $btnChangeNow.setAttribute('data-productid-yearly', $ele.getAttribute('data-productid-yearly'));
                $btnChangeNow.setAttribute('data-productid-monthly', $ele.getAttribute('data-productid-monthly'));
                $btnChangeNow.setAttribute('data-subscription-id', $ele.getAttribute('data-subscription-id'));

                // Modal mit Nachfrage zu Tarifwechsel öffnen
                window.Modals['modal-plan-change'].open();
            });
        });
        const $btnChangeNow = document.querySelector('#modal-plan-change button.paddle-change-now');
        if($btnChangeNow) {
            $btnChangeNow.addEventListener('click', event => {

                const frequencyValue = document.querySelector('input[name="frequency"]:checked').value;
                const isYearly = frequencyValue=='annually';
                const $ele = event.currentTarget;

                let productId = 0;
                if(isYearly === "true")     productId = parseInt( $ele.getAttribute('data-productid-yearly'), 10 );
                else                        productId = parseInt( $ele.getAttribute('data-productid-monthly'), 10 );

                const subscription_id = parseInt( $ele.getAttribute('data-subscription-id'), 10 );

                // Tarifwechsel per Ajax vornehmen
                const data = new FormData();
                data.append('product_id', productId);
                data.append('subscription_id', subscription_id);

                new Fetch().post(App.getUrl('panel/membership/change_paid_plan'), data)
                .then(response => {
                    window.Modals['modal-plan-change-success'].open();
                })
                .catch(error => {
                    alert("Error: " + error.message);
                })
                .finally(() => {

                });
            });
        }

    }
}

// Initialisierung wenn DOM geladen
App.domready(() => {
    if(document.querySelector('body').classList.contains('plans')) {
        new Page();
    }
});